var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import templateStr from 'text!./pagination.html';
import _ from 'underscore';
import assert from 'assert';
/**
 * Pagination directive
 *
 * Accepts a loadByOffset method with signature (offsetStart, offsetEnd) -> promise
 * loadByOffset should resolve with pageListData, actual data that would be shown
 *  {number}    pageListData.maxNumberOfResults     Maximum possible number of results for the given query
 *
 * Returned data will be available as pageListData in the transcluded scope
 *
 * @returns {Object}
 */
export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        transclude: true,
        scope: {
            loadByOffset: '&',
            pageSize: '@',
            pageTitle: '@',
            showWholeList: '=',
            tableTitle: '@',
            paginationHide: '='
        },
        link: function link($scope, $element) {

            //Added for pagination to take effect after custom filter in landing page quotes_MSF
            $scope.$on('customFilterSelected', function () {
                initPageData();
                loadInitData();
            });

            var pageSize = parseInt($scope.pageSize) || 10;
            $scope.loading = false;
            $scope.pageListData = {};
            $scope.showButtons = function () {
                if ($scope.showWholeList) {
                    return false;
                }
                return $scope.pageListData.items && $scope.pageListData.items.length > 0 && $scope.pageListData.maxNumberOfResults > pageSize;
            };

            initPageData();

            function initPageData() {
                $scope.pageListData = {};

                $scope.pageData = {
                    displayStart: 1,
                    displayEnd: pageSize
                };
            }

            function loadInitData() {
                loadData($scope.pageData.displayStart - 1, $scope.pageData.displayEnd - 1);
            }

            $scope.reload = loadInitData;

            function loadData(offsetStart, offsetEnd) {
                $scope.error = false;
                $scope.loading = true;
                var loadByOffset = $scope.loadByOffset()(offsetStart, offsetEnd);
                if (angular.isUndefined(loadByOffset)) {
                    return;
                }
                loadByOffset.then(function (data) {
                    //Fix for DEF0493
                    if (_.isUndefined(data) || data.maxNumberOfResults === 0) {
                        $scope.loading = false;
                    } else {
                        if (!_.isUndefined(data) && data.maxNumberOfResults !== 0) {
                            //Avoiding a data is undefined error during pagination.
                            assert((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && typeof data.maxNumberOfResults === 'number', 'Expecting a response with maxNumberOfResults key. ' + 'It will be available as pageListData in the transcluded scope.');

                            $scope.pageListData = data;
                            //Taking care of pageList setting error in the background.
                            if (!_.isUndefined($element.scope())) {
                                $element.scope().pageListData = data;
                            }
                            $scope.pageData.displayEnd = offsetEnd + 1;
                            $scope.pageData.displayStart = offsetStart + 1;
                            $scope.pageData.maxNumberOfResults = data.maxNumberOfResults;
                            $scope.loading = false;
                            if (!_.isUndefined($element.scope())) {
                                $element.scope().pageData = $scope.pageData;
                            }
                        }
                    }
                }).catch(function () {
                    $scope.error = true;
                });
            }

            $scope.nextPage = function () {
                var offsetEnd = $scope.pageData.displayEnd + pageSize > $scope.pageListData.maxNumberOfResults ? $scope.pageListData.maxNumberOfResults - 1 : $scope.pageData.displayEnd + (pageSize - 1);
                var offsetStart = $scope.pageData.displayStart + (pageSize - 1);
                loadData(offsetStart, offsetEnd);
            };

            $scope.previousPage = function () {
                if ($scope.pageData.displayStart !== 1 && !$scope.pageData.displayStart - pageSize < 1) {
                    var offsetStart = $scope.pageData.displayStart - pageSize >= 1 ? $scope.pageData.displayStart - pageSize - 1 : 0;
                    var offsetEnd = offsetStart + (pageSize - 1);
                    loadData(offsetStart, offsetEnd);
                }
            };

            var update = function update() {
                initPageData();
                loadInitData();
            };

            $scope.$watch('loadByOffset()', update);

            // Don't update when maxNumberOfResults is undefined. Watch should not trigger on initial value (otherwise 2 updates may be run initially).
            $scope.$watch('pageListData.maxNumberOfResults', _.after(2, function (maxNumberOfResults) {
                return maxNumberOfResults && update;
            }));
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PaginationDirective/Pagination.js
// module id = 1751
// module chunks = 0